<template>
  <div v-show="false" id="table" style="width: 800px;">
    <table v-if="printRes" border
      style="table-layout:fixed;border-collapse:collapse;font-size: 13px;width: 744px;margin:23px;margin-top:20px;text-align: center;"
      cellpadding="0" cellspacing="0">
      <caption align="top" style="font-weight: bold;font-size: 20px;margin-bottom: 10px;">广东省社会医疗保险医疗费用结算单</caption>
      <tbody style="border: 0;">
        <tr style="height: 28px;">
          <td colspan="2">机构名称</td>
          <td colspan="10">{{ printRes.setlinfo.fixmedins_name }}</td>
          <td colspan="2">机构编码</td>
          <td colspan="4">{{ printRes.setlinfo.fixmedins_code }}</td>
          <td colspan="4">医保结算级别</td>
          <td colspan="2">{{ printRes.setlinfo.hosp_live }}</td>
        </tr>
        <tr style="height: 28px;">
          <td colspan="4">就医登记号</td>
          <td colspan="8">{{ printRes.setlinfo.mdtrt_id }}</td>
          <td colspan="2">结算号</td>
          <td colspan="10">{{ printRes.setlinfo.setl_id }}</td>
        </tr>
        <tr style="height: 28px;">
          <td colspan="2">姓名</td>
          <td colspan="2">{{ printRes.setlinfo.psn_name }}</td>
          <td colspan="2">性别</td>
          <td colspan="1">{{ printRes.setlinfo.gend }}</td>
          <td colspan="2">生日日期</td>
          <td colspan="3">{{ printRes.setlinfo.brdy.slice(0, 10) }}</td>
          <td colspan="3" width="10%">个人电脑号</td>
          <td colspan="5" style="word-break:break-all;word-wrap:break-word;">{{ printRes.setlinfo.psn_no }}</td>
          <td colspan="2">人员类别</td>
          <td colspan="2">{{ printRes.setlinfo.psn_type }}</td>
        </tr>
        <tr style="height: 28px;">
          <td colspan="2">单位名称</td>
          <td colspan="8">{{ printRes.setlinfo.emp_name }}</td>
          <td colspan="2">联系电话</td>
          <td colspan="4">{{ printRes.setlinfo.v }}</td>
          <td colspan="2">身份证号</td>
          <td colspan="6">{{ printRes.setlinfo.certno }}</td>
        </tr>
        <tr style="height: 28px;">
          <td width="8%" colspan="2">门诊号</td>
          <td style="word-break:break-all;word-wrap:break-word;" width="8%" colspan="2">{{ printRes.setlinfo.ipt_op_no }}</td>
          <td width="8%" colspan="2">科别</td>
          <td width="8%" colspan="2">{{ printRes.setlinfo.adm_dept_name }}</td>
          <td width="8%" colspan="2">床号</td>
          <!-- <td width="8%" colspan="2">{{ printRes.setlinfo.adm_bed }}</td> -->
          <td width="8%" colspan="2"></td>
          <td width="8%" colspan="2">入院日期</td>
          <!-- <td width="8%" colspan="2">{{ printRes.setlinfo.begintime }}</td> -->
          <td width="8%" colspan="2" style="word-break:break-all;word-wrap:break-word;"></td>
          <td width="8%" colspan="2">出院日期</td>
          <!-- <td width="8%" colspan="2">{{ printRes.setlinfo.endtime }}</td> -->
          <td width="10%" colspan="2" style="word-break:break-all;word-wrap:break-word;"></td>
          <td width="8%" colspan="2">住院天数</td>
          <!-- <td width="8%" colspan="2">{{ printRes.setlinfo.ipt_days }}</td> -->
          <td width="10%" colspan="2" style="word-break:break-all;word-wrap:break-word;"></td>
        </tr>
        <tr style="height: 28px;">
          <td colspan="2">险种</td>
          <td colspan="2">{{ printRes.setlinfo.insutype }}</td>
          <td colspan="4" style="word-break:break-all;word-wrap:break-word;">入院第一诊断</td>
          <td colspan="6">{{ printRes.setlinfo.adm_dise_dscr }}</td>
          <td colspan="4">出院第一诊断</td>
          <td colspan="6" style="word-break:break-all;word-wrap:break-word;">{{ printRes.setlinfo.op_dise_info }}</td>
        </tr>
        <tr style="height: 28px;">
          <td colspan="2">业务类别</td>
          <td colspan="10">{{ printRes.setlinfo.med_type }}</td>
          <td colspan="2">结算时间</td>
          <td colspan="10">{{ printRes.setlinfo.setl_time }}</td>
        </tr>
        <tr style="height: 28px;">
          <td colspan="24" style="color:#e15b5c;text-align: left;height: 60px;border-bottom-color: #000;">
            本次就医：总费用{{ printRes.setlinfo.medfee_sumamt }} 元，基金支付总额{{ printRes.setlinfo.fund_pay_sumamt }}元，
            个人支付{{ selfPay }}元（起付线{{ printRes.setlinfo.act_pay_dedc }}元）。
          </td>
        </tr>
        <!-- <tr style="height: 28px;">
              <td colspan="2">费用名称</td>
              <td colspan="4">总费用</td>
              <td colspan="2">自费</td>
              <td colspan="4">部分项目自费</td>
            </tr>
            <tr style="height: 28px;" v-for="(item, ind) in printRes.setldetail" :key="ind">
              <td colspan="2">{{ item.med_chrgitm_type | dictText('med_chrgitm_type') }}</td>
              <td colspan="4">{{ item.item_sumamt }}</td>
              <td colspan="2">{{ item.item_ownpay_amt }}</td>
              <td colspan="4">{{ item.preselfpay_amt }}</td>
            </tr>
            <tr style="height: 28px;">
              <td colspan="2">合计</td>
              <td colspan="4">{{ count.total }}</td>
              <td colspan="2">{{ count.self }}</td>
              <td colspan="4">{{ count.other_self }}</td>
            </tr> -->
        <tr>
          <td colspan="12">
            <table style="width: 100%;border-collapse: collapse;text-align: center;" cellpadding="0" cellspacing="0">
              <tr style="height: 28px;">
                <td width="27%" style="border-right: 1px solid #333;border-bottom: 1px solid #333">费用名称</td>
                <td width="23%" style="border-right: 1px solid #333;border-bottom: 1px solid #333">总费用</td>
                <td width="23%" style="border-right: 1px solid #333;border-bottom: 1px solid #333">自费</td>
                <td width="27%" style="border-bottom: 1px solid #333">部分项目自费</td>
              </tr>
              <tr style="height: 28px;" v-for="(item) in oddCols" :key="item">
                <td style="border-right: 1px solid #333;border-bottom: 1px solid #333">{{
                    printRes.setldetail[item].med_chrgitm_type | dictText('med_chrgitm_type')
                }}</td>
                <td style="border-right: 1px solid #333;border-bottom: 1px solid #333">{{
                    printRes.setldetail[item].item_sumamt
                }}</td>
                <td style="border-right: 1px solid #333;border-bottom: 1px solid #333">{{
                    printRes.setldetail[item].item_ownpay_amt
                }}</td>
                <td style="border-bottom: 1px solid #333">{{ printRes.setldetail[item].preselfpay_amt }}
                </td>
              </tr>
              <tr style="height: 28px;">
                <td style="border-right: 1px solid #333;">合计</td>
                <td style="border-right: 1px solid #333;">{{ count.total }}</td>
                <td style="border-right: 1px solid #333;">{{ count.self }}</td>
                <td style="">{{ count.other_self }}</td>
              </tr>
            </table>
          </td>
          <td colspan="12">
            <table style="width: 100%;border-collapse: collapse;text-align: center;" cellpadding="0" cellspacing="0">
              <tr style="height: 28px;">
                <td width="27%" style="border-right: 1px solid #333;border-bottom: 1px solid #333">费用名称</td>
                <td width="23%" style="border-right: 1px solid #333;border-bottom: 1px solid #333">总费用</td>
                <td width="23%" style="border-right: 1px solid #333;border-bottom: 1px solid #333">自费</td>
                <td width="27%" style="border-bottom: 1px solid #333">部分项目自费</td>
              </tr>
              <tr style="height: 28px;" v-for="(item) in evenCols" :key="item">
                <td style="border-right: 1px solid #333;border-bottom: 1px solid #333">{{
                    printRes.setldetail[item].med_chrgitm_type | dictText('med_chrgitm_type')
                }}</td>
                <td style="border-right: 1px solid #333;border-bottom: 1px solid #333">{{
                    printRes.setldetail[item].item_sumamt
                }}</td>
                <td style="border-right: 1px solid #333;border-bottom: 1px solid #333">{{
                    printRes.setldetail[item].item_ownpay_amt
                }}</td>
                <td style="border-bottom: 1px solid #333">{{ printRes.setldetail[item].preselfpay_amt }}
                </td>
              </tr>
              <tr style="height: 28px;" v-if="evenCols.length < oddCols.length">
                <td style="border-right: 1px solid #333;border-bottom: 1px solid #333"></td>
                <td style="border-right: 1px solid #333;border-bottom: 1px solid #333"></td>
                <td style="border-right: 1px solid #333;border-bottom: 1px solid #333"></td>
                <td style="border-bottom: 1px solid #333"></td>
              </tr>
              <tr style="height: 28px;">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </table>
          </td>
        </tr>
        <tr style="text-align: left;height: 28px;">
          <td colspan="6">基本医疗保险统筹基金支付</td>
          <td colspan="6" align="center">{{ printRes.setlinfo.hifp_pay }}</td>
          <td colspan="6">大额基金支付</td>
          <td colspan="6" align="center">{{ printRes.setlinfo.hifob_pay }}</td>
        </tr>
        <tr style="text-align: left;height: 28px;">
          <td colspan="6">大病基金支付</td>
          <td colspan="6" align="center">{{ printRes.setlinfo.hifmi_pay }}</td>
          <td colspan="6">补充保险基金支付</td>
          <td colspan="6" align="center">{{ printRes.setlinfo.hifes_pay }}</td>
        </tr>
        <tr style="text-align: left;height: 28px;">
          <td colspan="6">医疗救助基金支付</td>
          <td colspan="6" align="center">{{ printRes.setlinfo.maf_pay }}</td>
          <td colspan="6">公务员基金支付</td>
          <td colspan="6" align="center">{{ printRes.setlinfo.cvlserv_pay }}</td>
        </tr>
        <tr style="text-align: left;height: 28px;">
          <td colspan="6">其他基金支付</td>
          <td colspan="6" align="center">{{ printRes.setlinfo.oth_pay }}</td>
          <td colspan="6">个人账户支付</td>
          <td colspan="6" align="center">{{ printRes.setlinfo.acct_pay }}</td>
        </tr>
        <tr style="text-align: left;height: 28px;">
          <td colspan="6">收款人：{{ printRes.setlinfo.opter_name }}</td>
          <td colspan="6">审核人：</td>
          <td colspan="6">制作人：{{ marker }}</td>
          <td colspan="6">打印日期：{{ new Date().getTime() | fmtDateTime }}</td>
        </tr>
        <tr>
          <td colspan="24" style="text-align: left;height: 60px;">
            注：1、部分项目自付全颇是指基本医疗保险范围内的项目需参保人先按规定比例自付的金额。<br>
            <span style="display:inline-block; text-indent: 2em;">2、此表由医院打印。</span><br>
            <span style="display:inline-block; text-indent: 2em;">3、比表一式两份，医院、参保人各一份。</span>
          </td>
        </tr>
        <tr style="border: 0px solid transparent">
          <td colspan="24" style="text-align: left;height: 50px;font-weight: bold;">
            病人家属签名：
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import api from "../../common/api";
export default {
  props: {
    curRow: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      printRes: null
    }
  },
  computed: {
    count () {
      const count = {
        total: 0,
        self: 0,
        other_self: 0
      }
      if (this.printRes.setldetail && this.printRes.setldetail.length) {
        this.printRes.setldetail.map(v => {
          count.total += Number(v.item_sumamt)
          count.self += Number(v.item_ownpay_amt)
          count.other_self += Number(v.preselfpay_amt)
        })
      }
      count.total = count.total.toFixed(2)
      count.self = count.self.toFixed(2)
      count.other_self = count.other_self.toFixed(2)
      return count
    },
    selfPay () {
      return (this.printRes.setlinfo.medfee_sumamt - this.printRes.setlinfo.fund_pay_sumamt).toFixed(2)
    },
    // 奇数列
    oddCols () {
      const arr = []
      this.printRes.setldetail.map((v, i) => {
        if ((i + 1)%2 !== 0) {
          arr.push(i)
        }
      })
      return arr
    },
    // 偶数列
    evenCols () {
      const arr = []
      this.printRes.setldetail.map((v, i) => {
        if ((i + 1)%2 === 0) {
          arr.push(i)
        }
      })
      return arr
    },
    marker () {
      const userInfo = sessionStorage.getItem('user')
      const name = userInfo ? JSON.parse(userInfo).name : ''
      return name
    },
  },
  methods: {
    getSettlInfo (curRow) {
      const data = {
        psn_no: curRow.insuranceNo,
        setl_id: curRow.insuranceSerialNo,
        mdtrt_id: curRow.mdtrtId
      }
      api.exec(5260, { data })
        .then((res) => {
          if (!res) return this.$message.success('暂无数据，无法打印！')
          console.log(res, 'res')
          this.printRes = res.output
          this.$nextTick(() => {
            this.$emit('preview')
          })
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err || '请求或接口异常',
            showClose: true,
            duration: 15000
          });
        })
        .finally(() => {
        })
    }
  }
}
</script>

<style lang="scss">

</style>
